import { Component, OnInit, Input, Output, ViewChild, ElementRef, OnChanges, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { OtaService } from '@myproject/components/ota/ota.service';
import { SharedService } from '../shared.service';
import { SupportOtaService } from '@myproject/components/support-ota/support-ota.service';
import { environment } from '@myenv/environment';
import { enMessage } from '../en-us-message';

@Component({
    selector: 'app-ota-file-upload-modal',
    templateUrl: './ota-file-upload-modal.component.html',
    styleUrls: ['./ota-file-upload-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OtaFileUploadModalComponent implements OnInit, OnChanges {

  @Input() showModal: boolean;
  @Input() hideModal: boolean;
  @Input() editModal?: Record<string, any> | '';
  @Output() uploadSuccess = new EventEmitter();
  @ViewChild('closeModal') btnClose: ElementRef;
  @ViewChild('fileName0') dotaFileName: ElementRef;
  @ViewChild('eotaFileName0') eotaFileName: ElementRef;
  readonly descMax = 250;
  EOTA_Enabled = false;
  EOTA_Authorities = {
    authorities: [] as string[]
  };
  responseMessage: any = {};
  fileUploadType: string = null;
  folders: any = [];
  deviceFileTypes = [
    { key: 'CFG', displayName: 'Configurations', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
    { key: 'FW', displayName: 'Firmwares', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
    { key: 'PACKAGE', displayName: 'Package', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
    { key: 'SDK', displayName: 'SDK', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
  ];
  ecuFileTypes = [
    { key: 'EOTA', displayName: 'ECU OTA', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
    // { key: 'SDK', displayName: 'SDK', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
  ];
  dataSource = [
    { a: '', b: '' }
  ];
  columns: {
    otaType: string;
    newFolderName: string;
    DescrName: string;
    fileName: string;
    fileExtension: string;
    ecuGroupList: any[];
    selectedEcuGroup: any;
    ecuNameList: any[];
    selectedEcuName: any;
    fileVersion: any;
    fileId?: string;
    folder: any;
  }[] = [{
    otaType: 'CFG',
    newFolderName: '',
    DescrName:'',
    fileName: '',
    fileExtension: '.gz,.tlv,.bin,.enc,.en',
    ecuGroupList: [],
    selectedEcuGroup: undefined,
    ecuNameList: [],
    selectedEcuName: undefined,
    fileVersion: undefined,
    folder: null
  }];
  uploadProgress = 0;
  incrimentBy: number;
  uploadedFile: any;
  attachedFile = false;
  formsNotValid = 0;
  validForm = true;
  disable = false;
  isSupportUser: boolean;
  otaeditfile:boolean =false;

  constructor(
    private otaService: OtaService,
    private sharedService: SharedService,
    private supportOtaService: SupportOtaService
  ) { }

  ngOnInit() {
    const pm = localStorage.getItem('permissionModules');
    this.isSupportUser = pm.includes('SUPPORT-OTA') ? true : false;
    const modules = JSON.parse(localStorage.getItem('accessRoleModules'));
    this.EOTA_Authorities = modules.find(module => module.name === 'EOTA');
    if (pm.includes('AZUGA-DASHBOARD')) {
      this.deviceFileTypes.pop();
    }
    this.getFolders();
  }

  ngOnChanges(changes) {
    // Show Modal
    if (changes.showModal && changes.showModal.previousValue !== undefined) {
      if (changes.showModal.previousValue !== changes.showModal.currentValue) {
        const eota = this.EOTA_Authorities;
        if (!(eota && eota.authorities && eota.authorities.includes('WRITE'))) {
          this.onTypeSelect('device');
        } else {
          this.fileUploadType = null;
        }
        document.getElementById('uploadFileModalBtn').click();
        this.otaeditfile = false;
      }
    }
    // Hide Modal
    if (changes.hideModal && changes.hideModal.previousValue !== undefined) {
      if (changes.hideModal.previousValue !== changes.hideModal.currentValue) {
        document.getElementById('closeModal').click();
        this.otaeditfile = false;
      }
    }
    // Edit Modal
    if(changes.editModal ){
      if(changes.editModal.currentValue !== undefined){
        if (!this.EOTA_Enabled) {
          this.onTypeSelect('device');
        } else {
          this.fileUploadType = null;
        }
        this.fillFiledetails(changes.editModal.currentValue);
        this.otaeditfile = true;
        this.validForm = true;
        document.getElementById('uploadFileModalBtn').click();
      }
    }
  }

  onTypeSelect(type) {
    this.fileUploadType = type;
    this.addNewFile(0);
    let element;
    if (type === 'device') element = this.dotaFileName;
    else if (type === 'ecu') element = this.eotaFileName;
    this.autofocus(element);
  }

  addNewFile(index) {
    this.uploadProgress = 0;
    this.incrimentBy = 0;
    this.dataSource = [
      { a: '', b: '' }
    ];
    this.columns = [{
      otaType: this.fileUploadType === 'device' ? 'CFG' : 'EOTA',
      newFolderName: '',
      DescrName:'',
      fileName: '',
      fileExtension: '.gz,.tlv,.bin,.enc,.en',
      ecuGroupList: [],
      selectedEcuGroup: '',
      ecuNameList: [],
      selectedEcuName: '',
      fileVersion: '',
      folder: null
    }];
    if (this.fileUploadType === 'ecu') { this.getEcuGroups(index); }
  }

  addRow() {
    this.dataSource.push({ a: '', b: '' });
    let columnObject = {
      otaType: this.fileUploadType === 'device' ? 'CFG' : 'EOTA',
      newFolderName: '',
      DescrName:'',
      fileName: '',
      fileExtension: '.gz,.tlv,.bin,.enc,.en',
      ecuGroupList: [],
      selectedEcuGroup: '',
      ecuNameList: [],
      selectedEcuName: '',
      fileVersion: '',
      folder: null
    };
    this.columns.push(columnObject);
    if (this.fileUploadType === 'ecu') { this.getEcuGroups(this.columns.length - 1); }
  }

  /* To delete the row with select box and input box
      on clicking times(X) icon
  */
  deleteRow(index) {
    this.dataSource.splice(index, 1);
    this.columns.splice(index, 1);
  }

  changeExtension(index) {
    let types;
    if (this.fileUploadType === 'device') {
      types = this.deviceFileTypes;
    } else {
      types = this.ecuFileTypes;
    }
    types.map(item => {
      if (item.key === this.columns[index].otaType) {
        this.columns[index].fileExtension = item.fileExtension;
      }
    });
  }

  getEcuGroups(index) {
    this.otaService.getEcuGroups().subscribe({
      next: res => {
        this.columns[index].ecuGroupList = res;
        if (res.length) {
          this.columns[index].selectedEcuGroup = res[0];
          this.getEcuNames(index);
        } else {
          this.columns[index].selectedEcuGroup = '';
        }
      },
      error: error => {
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  getEcuNames(index) {
    this.otaService.getEcuNames(this.columns[index].selectedEcuGroup).subscribe({
      next: res => {
        this.columns[index].ecuNameList = res;
        if (res.length) {
          this.columns[index].selectedEcuName = res[0];
        } else {
          this.columns[index].selectedEcuName = '';
        }
      },
      error: error => {
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  // To upload a file
  getUploadedFile(file, i) {
    this.columns[i]['fileName'] = file.files[0];
    if(this.columns[i]['newFolderName'].length ==0){
      this.columns[i]['newFolderName'] =  file.files[0].name;
    }
    if (file.value) {
      this.uploadedFile = file;
      this.validForm = true;
    } else {
      this.formsNotValid = this.formsNotValid + 1;
      this.validForm = false;
    }
  }

  uploadMultiFiles(isValid, form) {
    if (this.otaeditfile) {
      this.editfileConfigXL(this.columns[0], form);
      return;
    }
    if (isValid) {
      this.incrimentBy = 0;
      this.incrimentBy = 100 / this.columns.length;
      for (let i = 0; i < this.columns.length; i++) {
        if (!this.columns[i]['fileName']) {
          this.formsNotValid = this.formsNotValid + 1;
          this.attachedFile = true;
        } else {
          this.formsNotValid = 0;
          this.attachedFile = false;
        }
      }
      if (this.formsNotValid == 0 && isValid) {
        for (let i = 0; i < this.columns.length; i++) {
          this.uploadConfigXL(isValid, this.columns[i], form, i);
        }
      }
    }
  }

  // To add a new file
  uploadConfigXL(isValid, column, form, index) {
    if (isValid) {
      // if (this.searchModel.userIds) {
      //   this.searchModel.userIds = this.searchModel.userIds.toString();
      // }
      this.disable = true;
      if (!this.validForm) {
        this.attachedFile = true;
        this.disable = false;
      } else {
        this.attachedFile = false;
        let file = column.fileName;
        if (file) {
          let formData = new FormData();
          formData.append('file', file);
          formData.append('description',column.DescrName)
          if(column.folder && column.folder.name){
            formData.append('folderName',column.folder.name);
          }
          let service = this.isSupportUser ? this.supportOtaService : this.otaService;
          service.uploadXL(
            formData, column.newFolderName, column.otaType, column.fileVersion, column.selectedEcuGroup, column.selectedEcuName
          ).subscribe(res => {
            this.responseMessage = { success: true, message: enMessage.successFile };
            this.sharedService.setResponseMessage(this.responseMessage);
            this.btnClose.nativeElement.click();
            this.uploadSuccess.next(null);
            this.disable = false;
            this.uploadProgress += this.incrimentBy;
            if (index == this.columns.length - 1) {
              this.btnClose.nativeElement.click();
              form.resetForm();
            }
          }, error => {
            if (index == this.columns.length - 1) {
              this.btnClose.nativeElement.click();
              form.resetForm();
            }
            // if (error.errorCode == 'OTA002') {
            //   this.responseMessage = { success: false, message: `File name already exists with ${error.args[0]}` };
            //   this.sharedService.setResponseMessage(this.responseMessage);
            // } else {
              this.sharedService.getErrorMsg(error);
            // }
            this.disable = false;
          });
        } else {
          this.responseMessage = { success: false, message: enMessage.errorNoChooseCsvFile }
          this.sharedService.setResponseMessage(this.responseMessage);
          this.disable = false;
        }
      }
    } else {
      this.attachedFile = true;
    }
  }

  closeModal(f?) {
    this.fileUploadType = null;
    this.attachedFile = false;
    document.getElementById('close-modal').click();
    if (f) {
      f.resetForm();
    }
  }

  autofocus(element) {
    if (this.fileUploadType === null) return;
    setTimeout(() => {
      const inputElem = <HTMLInputElement>element.nativeElement;
      inputElem.select();
    }, 200);
  }

  fillFiledetails(row){
    this.dataSource = [
      { a: '', b: '' }
    ];
    // Extract folder name from uploadedFileName (format: "FolderName/FileName.txt" or "FileName.txt")
    let folderValue = null;
    let fileNameOnly = row.fileName || '';
    if (row.fileName && row.fileName.includes('/')) {
      const parts = row.fileName.split('/');
      const folderName = parts.slice(0, -1).join('/');
      fileNameOnly = parts[parts.length - 1];
      if (folderName) {
        const foundFolder = this.folders.find(f => f.name === folderName);
        folderValue = foundFolder || { name: folderName };
      }
    }
    let columnObject = {
      otaType: row.fileType,
      newFolderName: fileNameOnly,
      DescrName: (row.description || '').slice(0, this.descMax),
      fileName: row.fileName,
      fileExtension: '.gz,.tlv,.bin,.enc,.en',
      ecuGroupList: [],
      selectedEcuGroup: '',
      ecuNameList: [],
      selectedEcuName: '',
      fileId: row.filesBundleId ?? row.bundleId ?? row._id ?? row.fileId ?? row.id,
      fileVersion: row.fileVersion,
      folder: folderValue
    };
    this.attachedFile = true;
    this.columns=[];
    this.columns.push(columnObject);
  }

  cancelModal(f?){
    document.getElementById('close-modal').click();
    if (f) {
      f.resetForm();
    }
  }

  onKeyPress(val){
    var value = val.target.value;
    if(value.length >= this.descMax){
      this.responseMessage = { success: false, enMessage: `Description can not be more than ${this.descMax} Characters.` };
      this.sharedService.setResponseMessage(this.responseMessage);
    }
  }

  getFolders() {
    this.otaService.getAllFolders().subscribe({
      next: res => {
        this.folders = res;
      },
      error: error => {
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  onFolderChange(e, index) {
    if (this.columns[index].folder && !this.columns[index].folder.customerId) {
      this.otaService.createFolder(this.columns[index].folder.name).subscribe({
        next: res => {
          this.responseMessage = {
            success: true,
            message: 'Folder created successfully'
          };
          this.sharedService.setResponseMessage(this.responseMessage);
          this.getFolders();
        },
        error: error => {
          this.sharedService.getErrorMsg(error);
        }
      });
    }
  }

  editfileConfigXL(column, form) {
    this.disable = true;
    this.attachedFile = false;
    if (column.fileId) {
      const onSuccess = (message: string) => {
        this.responseMessage = { success: true, message };
        this.sharedService.setResponseMessage(this.responseMessage);
        this.btnClose.nativeElement.click();
        this.uploadSuccess.next(null);
        this.disable = false;
        form.resetForm();
      };
      const onError = (error) => {
        this.sharedService.getErrorMsg(error);
        this.disable = false;
      };

      if (column.otaType === 'PACKAGE') {
        this.otaService.updateFilesBundle({
          bundleId: column.fileId,
          fileName: column.newFolderName || column.fileName,
          fileVersion: column.fileVersion,
          description: column.DescrName,
        }).subscribe(
          () => onSuccess('Package updated successfully.'),
          onError
        );
      } else {
        const service = this.isSupportUser ? this.supportOtaService : this.otaService;
        service.editfile(column.DescrName, column.fileId).subscribe(
          () => onSuccess('Description Updated successfully.'),
          onError
        );
      }
    } else {
      this.responseMessage = {
        success: false,
        message: "Unable to update this package because its identifier is missing."
      };
      this.sharedService.setResponseMessage(this.responseMessage);
      this.disable = false;
    }
  }

  closeOTAFileUploadModal() {
    this.fileUploadType = null;
    this.attachedFile = false;
    document.getElementById('close-modal').click();
  }

}
